<template>
  <div class="d-flex overflow-auto">
    <div
      :class="[
        'huntingWords-theme-default position-relative mx-auto  m-3',
        showGrid && 'border',
      ]"
      :style="{
        'grid-template-rows': `repeat(${rows}, 2.5rem)`,
        'grid-template-columns': `repeat(${columns}, 2.5rem)`,
      }"
    >
      <div
        v-for="cell in table"
        :key="`${cell.positionx}-${cell.positiony}`"
        :data-positiony="cell.positiony"
        :data-positionx="cell.positionx"
        :class="[
          'd-flex justify-content-center font-weight-bold align-items-center text-center',
          showGrid && 'border-cell',
        ]"
      >
        {{ cell.text }}
      </div>

      <!-- Highlighted Words-->
      <template v-if="showWordPositions">
        <div
          v-for="(highlight, i) in highlightedWords"
          :key="'highlight-' + i"
          :style="getHighlightStyle(highlight)"
          :class="[
            highlightMode === 'border'
              ? 'highlight-border'
              : `highlight-${highlight.direction} highlight-border-color`,
          ]"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { CELL_SIZE, DIRECTION_CONFIG } from './HuntingWordsModel';

export default {
  name: 'huntingWords-grid',
  props: {
    rows: {
      type: Number,
      required: true,
    },
    columns: {
      type: Number,
      required: true,
    },
    table: {
      type: Array,
      required: true,
    },
    highlightedWords: {
      type: Array,
      required: true,
    },
    showGrid: {
      type: Boolean,
      required: true,
    },
    showWordPositions: {
      type: Boolean,
      required: true,
    },
    highlightMode: {
      type: String,
      required: true,
    },
  },
  methods: {
    getHighlightStyle({
      row, col, direction, length,
    }) {
      const size = CELL_SIZE;

      const config = DIRECTION_CONFIG[direction];
      const { transform, origin: transformOrigin } = config;

      if (config) {
        const width = config.getWidth(size, length);
        const height = config.getHeight(size, length);

        const top = `${row * size}px`;
        const left = config?.adjustCol
          ? `${(col + 1) * size}px`
          : `${col * size}px`;

        return {
          position: 'absolute',
          top,
          left,
          width: `${width}px`,
          height: `${height}px`,
          transform,
          transformOrigin,
          borderRadius: '12px',
          pointerEvents: 'none',
        };
      }

      return null;
    },
  },
};
</script>

<style lang="scss" scoped>
.huntingWords-theme-default {
  display: inline-grid;
  grid-auto-rows: 60px;
  grid-auto-columns: 60px;
  font-size: 18px;
  margin-left: 1px;
}

.border-cell {
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.highlight-border-color {
  border: 1px solid rgba(128, 128, 128, 0.8);
}

.highlight-border {
  border: 2px solid rgba(128, 128, 128, 0.8);
}

.highlight-horizontal {
  background-color: rgba(255, 255, 0, 0.3);
}

.highlight-invertedHorizontal {
  background-color: rgba(32, 178, 170, 0.3);
}

.highlight-vertical {
  background-color: rgba(144, 238, 144, 0.3);
}

.highlight-invertedVertical {
  background-color: rgba(100, 149, 237, 0.3);
}

.highlight-down-right {
  background-color: rgba(255, 200, 130, 0.3);
}

.highlight-down-left {
  background-color: rgba(255, 99, 71, 0.3);
}

.highlight-up-right {
  background-color: rgba(60, 179, 113, 0.3);
}

.highlight-up-left {
  background-color: rgba(147, 112, 219, 0.3);
}

</style>
